import React from 'react';
import * as PropTypes from 'prop-types';
import './Layout.css';

const MainContent = ({ startHigher, children }) => {
  return (
  <main className="dp-main" style={ startHigher ? { marginTop: '-' + startHigher } : {} }>
    <div className="dp-centre">
      {children}
    </div>
  </main> );
}

// Validate prop type parameters.
MainContent.propTypes = {
  startHigher: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)]),
};

MainContent.defaultProps = {
  startHigher: null,
};

export default MainContent;
